import {
  COMPANY_All_PURPOSE,
  COMPANY_ONLINE,
  COMPANY_RESALE,
  COMPANY_SENIOR,
  COMPANY_UPGRADE
} from "@/constant/VIP_COMPANY";

export const INTRO_COMPANY = {

  /* 企业VIP可享受一站式服务 */
  ONE_STOP_SERVICE: {
    LABEL_LIST: [
      '全站海量 <br>下载+图片包',
      '创建团队 <br>子帐号赋权',
      '支持新增 <br>授权主体',
      '精品内容 <br>紧跟热点',
      '侵权赔付 <br>安心保障',
      '版权备案 <br>商用无忧',
      '授权证书 <br>在线下载',
      '企业VRF <br>授权协议',
      '专属客服 <br>专业服务',
      '电子发票 <br>在线申请',
    ],
    DESC_LIST: [
      '全站原创内容：3D、海报、电商、插画等海量下载，图片包免费下载',
      '可随时增加/邀请/移除子帐号，便于管理',
      '服务多家主体，提供安全可靠的内容服务和企业授权',
      '每日新增原创内容，寻找灵感不用愁',
      '保障企业用户权益，享受版权纠纷赔付',
      '作品通过国家版权局备案认证，以确保作品权利归属明确',
      '在线生成授权书，并下载本地保存，版权完备、授权清晰',
      'VRF授权模板，保障企业下载使用不会引起版权纠纷',
      '企业VIP有专属客服，随时为您解决遇到的各项问题',
      '为企业VIP提供增值税发票，在线申请，为企业报销提供便捷服务',
    ]
  },

  /* 使用流程 */
  USE_FLOW: {
    STEP_LIST: [
      {
        label: '选择授权版本',
        value: '根据使用范围购买对应的VIP版本'
      },
      {
        label: '购买企业认证',
        value: '进入企业服务，填写企业资料'
      },
      {
        label: '授权主体认证',
        value: '填写认证主体信息（与企业一致可一键代入）'
      },
      {
        label: '邀请成员',
        value: '团队共享，填写成员ID或发出邀请链接'
      },
    ]
  },


  VIP_CARD_LIST: [
    /*{
      label: COMPANY_ONLINE.FULL_NAME2,
      name: '线上版',
      subTitle: {
        main: '1家主体',
        account: '1个帐号'
      },
      ID: COMPANY_ONLINE.ID,
      PARENT_ID: COMPANY_ONLINE.PARENT_ID,
      price: COMPANY_ONLINE.PRICE,
      time: '/年',
      interests: [
        '「线上版」商用授权书',
        '享￥1,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途'
      ],
      interestList: [
        '','1家','初创企业','1个','￥1,000','「线上版」商用授权书','海量下载','全球','永久',
        1,1,'',1,'',0,0,0,'',0,'',0,'',0,'',0,'',0,'',0,'',0,'',1,1]
    },*/
    {
      label: COMPANY_All_PURPOSE.FULL_NAME2,
      name: '标准版',
      subTitle: {
        main: '1家主体',
        account: '1个帐号'
      },

      value: 2,
      ID: COMPANY_All_PURPOSE.ID,
      PARENT_ID: COMPANY_All_PURPOSE.PARENT_ID,
      desc: '商用授权，全渠道使用',
      className: 'business-vip',
      price: COMPANY_All_PURPOSE.PRICE,
      time: '/年',
      interests: [
        '「标准版」商用授权书',
        '享￥5,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途',
        '物料印刷限5万份',
        '线下活动'
      ],
      interestList: [
        '', '1家', `初创企业<br>（注册资本≤100万）`, '1个', '￥5,000',
        '「标准版」商用授权书', '200张/年', '全球', '永久', 1,
        1, '', 1, '', 0,
        '', 0, 0, '', 0,
        '', 0, '', 0, '',
        0, '', 0, '', 0,
        '', 0, '', 1, 1
      ]
    },
    {
      name: '升级版',
      subTitle: {
        main: '1家主体',
        account: '4个帐号'
      },

      value: 2,
      ID: COMPANY_UPGRADE.ID,
      PARENT_ID: COMPANY_UPGRADE.PARENT_ID,
      desc: '商用授权，全渠道使用',
      className: 'business-vip',
      price: COMPANY_UPGRADE.PRICE,
      time: '/年',
      interests: [
        '「升级版」商用授权书',
        '享￥20,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途',
        '物料印刷限5万份',
        '线下活动',
        '户外广告'
      ],
      interestList: [
        '', '1家', `微型企业 <br>（注册资本≤500万）`, '4个', '￥20,000',
        '「升级版」商用授权书', '海量下载', '全球', '永久', 1,
        1, '', 1, '', 1,
        '', '限5万份', 1, '', 0,
        '', 0, '', 0, '',
        0, '', 0, '', 0,
        '', 0, '', 1, 1
      ]
    },
    {
      name: '高级版',
      subTitle: {
        main: '1家主体',
        account: '10个帐号'
      },

      value: 2,
      ID: COMPANY_SENIOR.ID,
      PARENT_ID: COMPANY_All_PURPOSE.PARENT_ID,
      desc: '商用授权，全渠道使用',
      className: 'business-vip',
      price: COMPANY_SENIOR.PRICE,
      time: '/年',
      interests: [
        '「高级版」商用授权书',
        '享￥50,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途',
        '物料印刷限5万份',
        '线下活动',
        '户外广告',
        '传媒影视'
      ],
      interestList: [
        '', '1家', `小型企业 <br>（注册资本≤1000万）`, '10个', '￥50,000',
        '「高级版」商用授权书', '海量下载', '全球', '永久', 1,
        1, '', 1, '', 1,
        '', '限50万份', 1, '', 1,
        '', 0, '', 0, '',
        0, '', 0, '', 0,
        '', 0, '', 1, 1
      ]
    },
    {
      name: '转售版',
      subTitle: {
        main: '1家主体',
        account: '20个帐号'
      },

      value: 2,
      ID: COMPANY_RESALE.ID,
      PARENT_ID: COMPANY_RESALE.PARENT_ID,
      desc: '商用授权，全渠道使用',
      className: 'business-vip',
      price: COMPANY_RESALE.PRICE,
      time: '/年',
      interests: [
        '「转售版」商用授权书',
        '享￥100,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途',
        '物料印刷限5万份',
        '线下活动',
        '户外广告',
        '传媒影视',
        '转售商品限50万份'
      ],
      interestList: [
        '', '1家', `中型企业 <br>（注册资本≤2000万）`, '20个', '￥100,000',
        '「转售版」商用授权书', '海量下载', '全球', '永久', 1,
        1, '', 1, '', 1,
        '', '限100万份', 1, '', 1,
        '', '限50万份', '', 0, '',
        0, '', 0, '', 0,
        '', 0, '', 1, 1
      ]
    },
    {
      name: '转售版',
      subTitle: {
        main: '1家主体',
        account: '20个帐号'
      },

      value: 2,
      ID: -999,
      PARENT_ID: COMPANY_RESALE.PARENT_ID,
      desc: '商用授权，全渠道使用',
      className: 'business-vip custom',
      price: COMPANY_RESALE.PRICE,
      time: '/年',
      interests: [
        '「转售版」商用授权书',
        '享￥100,000保障金',
        '全站海量下载+图片包'
      ],
      scope: [
        '线上用途',
        '物料印刷限5万份',
        '线下活动',
        '户外广告',
        '传媒影视',
        '转售商品限50万份'
      ],
      interestList: [
        '', '1家起（可加购）', `注册资本＞2000万 <br>国企/大型企业/事业单位`, '1个起（可加购）', '最高全额赔付',
        '「定制版」商用授权书', '海量下载', '全球', '永久', 1,
        1, '', 1, '', 1,
        '', '按需定制', 1, '', 1,
        '', '按需定制', '', '按需定制', '',
        '按需定制', '', '按需定制', '', '按需定制',
        '', '按需定制', '', 1, 1
      ]
    },

  ]
}

